import React from 'react'
import type { FaxPreviewHooks } from './useFaxPreview'
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons'
import { isFaxSentView } from '@utils/fax.util'
import { useAppSelector } from '@store/hooks'

type Props = {
  hooks: FaxPreviewHooks
}

const FaxMessageList: React.FC<Props> = ({ hooks }) => {
  const showStatus = isFaxSentView(hooks.activeFolder)
  const showUnread = useAppSelector(
    (state) => state.fax.settings?.show_unread ?? false,
  )
  return (
    <div className="fax-message-list">
      {hooks.pagedMessages.map((fax) => {
        const id = fax.fax_message_id
        const isActive = id === hooks.selectedFaxId
        const showAdd = hooks.shouldShowAddContact(fax)
        return (
          <div
            key={id}
            className={`fax-message-row${isActive ? ' selected' : ''}${showUnread && !fax.is_read ? ' unread' : ''}`}
            onClick={() => hooks.handleRowClick(fax)}
            onKeyDown={(e) => {
              if (e.key !== 'Enter' && e.key !== ' ') return
              if (e.target !== e.currentTarget) return
              e.preventDefault()
              hooks.handleRowClick(fax)
            }}
            role="button"
            tabIndex={0}
            aria-label={hooks.getDisplayLabel(fax)}
          >
            <div className="fax-row-main">
              <CheckBoxComponent
                checked={hooks.isRowSelected(id)}
                onClick={(e) => e.stopPropagation()}
                change={() => {
                  hooks.toggleRowSelected(fax)
                }}
              />
              <span className="e-label">{hooks.getDisplayLabel(fax)}</span>
              {showStatus &&
                fax.status &&
                (['queued', 'sending'].includes(fax.status) ? (
                  <span
                    className="mgc_loading_2_fill fax-status-icon fax-status-sending"
                    data-bs-toggle="tooltip"
                    title="Sending in progress"
                  />
                ) : fax.status === 'failed' ? (
                  <>
                    <span
                      className="mgc_alert_fill fax-status-icon fax-status-failed"
                      data-bs-toggle="tooltip"
                      title="Failed to send"
                    />
                    <button
                      type="button"
                      className="unstyled-button fax-retry-link"
                      title="Retry sending"
                      onClick={(e) => {
                        e.stopPropagation()
                        hooks.onRetry(fax)
                      }}
                    >
                      Retry
                    </button>
                  </>
                ) : null)}
              {fax.fax_tag && (
                <span
                  className="fax-tag"
                  style={{ backgroundColor: `var(--${fax.fax_tag.color})` }}
                >
                  {fax.fax_tag.tag_name}
                </span>
              )}
              {showAdd && (
                <button
                  type="button"
                  className="unstyled-button fax-add-contact-link"
                  onClick={(e) => {
                    e.stopPropagation()
                    hooks.onAddToContacts(fax)
                  }}
                >
                  • Add to contacts
                </button>
              )}
            </div>
            <span className="fax-row-date">{hooks.getListDate(fax)}</span>
          </div>
        )
      })}
    </div>
  )
}

export default FaxMessageList
